// extracted by mini-css-extract-plugin
module.exports = {"selectors":"styles_selectors__1V0nZ"};